<template>
  <div class="page">
    <!-- 广告图 -->
    <Banner />
    <!-- 列表 -->
    <List />
    <!-- 分页 -->
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import List from './components/list.vue'
export default {
  components: {
    Banner,
    List
  },
  created() {
    console.log('溯源新闻')
  }
}
</script>

<style lang="scss" scoped>
.pagination-box {
  width: 15rem;
  padding: 0.375rem 0 1rem;
  margin: 0 auto;
  text-align: right;
  ::v-deep .el-pagination {
    .btn-prev,
    .btn-next {
      min-width: 0.375rem;
      background-color: transparent;
      margin: 0 0.0625rem;
      .el-icon {
        font-size: 0.25rem;
      }
    }
    .el-pager {
      li {
        min-width: 0.375rem;
        margin: 0 0.0625rem;
        padding: 0 0.05rem;
        border-radius: 50%;
        font-size: 0.175rem;
        height: 0.35rem;
        line-height: 0.35rem;
      }
    }
  }
}
</style>
